export const columns = [
  {
    key: 'riskName',
    label: 'Risk Name',
    value: 'riskName',
    isSortable: true,
    isChecked: true,
    isPinned: true,
    hasCheckbox: true,
    width: '12.25rem',
  },
  {
    key: 'function',
    label: 'Function',
    value: 'function',
    isSortable: true,
    isChecked: true,
    width: '12.25rem',
  },
  {
    key: 'riskDescription',
    label: 'Risk Description',
    value: 'riskDescription',
    isSortable: true,
    isChecked: true,
    width: '12.25rem',
  },
  {
    key: 'riskScore',
    label: 'Risk Score',
    value: 'riskScore',
    isSortable: true,
    isChecked: true,
    width: '100%',
    minWidth: '10rem',
  },
  {
    key: 'application',
    label: 'Application',
    value: 'application',
    isSortable: true,
    isChecked: true,
    width: '100%',
    minWidth: '10rem',
  },
  {
    key: 'accountName',
    label: 'Account Name',
    value: 'accountName',
    isSortable: true,
    isChecked: true,
    width: '100%',
    minWidth: '10rem',
  },
  {
    key: 'actualVsPotential',
    label: 'Actual Vs Potential',
    value: 'actualVsPotential',
    isSortable: true,
    isChecked: true,
    width: '100%',
    minWidth: '10rem',
  },
  {
    key: 'riskType',
    label: 'Risk Type',
    value: 'riskType',
    isSortable: true,
    isChecked: true,
    width: '100%',
    minWidth: '10rem',
  },
  {
    key: 'randomColumn1',
    label: 'Random Column 1',
    value: 'randomColumn1',
    isSortable: true,
    isChecked: true,
    width: '100%',
    minWidth: '10rem',
  },
  {
    key: 'randomColumn2',
    label: 'Random Column 2',
    value: 'randomColumn2',
    isSortable: true,
    isChecked: true,
    width: '100%',
    minWidth: '10rem',
  },
  {
    key: 'randomColumn3',
    label: 'Random Column 3',
    value: 'randomColumn3',
    isSortable: true,
    isChecked: true,
    width: '100%',
    minWidth: '10rem',
  },
  {
    key: 'randomColumn4',
    label: 'Random Column 4',
    value: 'randomColumn4',
    isSortable: true,
    isChecked: true,
    width: '100%',
    minWidth: '10rem',
  },
  {
    key: 'randomColumn5',
    label: 'Random Column 5',
    value: 'randomColumn5',
    isSortable: true,
    isChecked: true,
    width: '100%',
    minWidth: '10rem',
  },
  {
    key: 'actionColumn',
    label: 'actionColumn',
    value: 'actionColumn',
    isPinned: true,
    isColumnConfigEnabled: true,
    isChecked: true,
    width: '3rem',
  },
];

export const sortOptions = [
  {
    label: 'Ascending',
    value: 'asc',
    isDisabled: false,
    isChecked: false,
    icon: 'ArrowDown',
    shouldShowCheckIcon: true,
  },
  {
    label: 'Descending',
    value: 'desc',
    isDisabled: false,
    isChecked: false,
    icon: 'ArrowUp',
    shouldShowCheckIcon: true,
  },
  {
    label: 'Filter',
    value: 'filter',
    isDisabled: false,
    isChecked: false,
    icon: 'Filter',
    shouldShowCheckIcon: true,
  },
  {
    label: 'DividerOne',
    value: 'dividerOne',
    isDivider: true,
  },
  {
    label: 'Hide',
    value: 'hide',
    isDisabled: false,
    isChecked: false,
    icon: 'VisibilityOff',
    shouldShowCheckIcon: true,
  },
];

export const sortConfigs = [
  { key: 'riskName', sortOptions },
  { key: 'function', sortOptions },
  { key: 'riskDescription', sortOptions },
  { key: 'riskScore', sortOptions },
  { key: 'application', sortOptions },
  { key: 'accountName', sortOptions },
  { key: 'actualVsPotential', sortOptions },
  { key: 'riskType', sortOptions },
  { key: 'randomColumn1', sortOptions },
  { key: 'randomColumn2', sortOptions },
  { key: 'randomColumn3', sortOptions },
  { key: 'randomColumn4', sortOptions },
  { key: 'randomColumn5', sortOptions },
];

export const allReports = [
  'Violations',
  'Entitlements with Inherent Risks',
  'Roles with Inherent Risks Summary',
  'Mitigating Controls About to Expire in 30 Days',
  'Mitigating Controls Assigned Associations End Date in 30 days',
];
